const PLACEHOLDER = 'Select locations';

function summarize(field: HTMLElement): void {
  const summary = field.querySelector<HTMLElement>('[data-role="geo-summary"]');
  const toggle = field.querySelector<HTMLButtonElement>('[data-role="geo-toggle"]');
  if (!summary) return;

  const boxes = Array.from(
    field.querySelectorAll<HTMLInputElement>('input[type="checkbox"]')
  );
  const labels = boxes
    .filter(cb => cb.checked)
    .map(cb => field.querySelector(`label[for="${cb.id}"]`)?.textContent?.trim() || cb.value);

  summary.textContent = labels.length ? labels.join(', ') : PLACEHOLDER;
  summary.classList.toggle('text-muted', labels.length === 0);

  if (toggle) {
    const allDisabled = boxes.length > 0 && boxes.every(cb => cb.disabled);
    toggle.disabled = allDisabled;
    if (allDisabled) closeMenu(field);
  }
}

function positionMenu(field: HTMLElement): void {
  const toggle = field.querySelector<HTMLElement>('[data-role="geo-toggle"]');
  const menu = field.querySelector<HTMLElement>('[data-role="geo-menu"]');
  if (!toggle || !menu) return;
  const rect = toggle.getBoundingClientRect();
  menu.style.top = `${rect.bottom + 4}px`;
  menu.style.left = `${rect.left}px`;
  menu.style.width = `${rect.width}px`;
}

function openMenu(field: HTMLElement): void {
  field.querySelector('[data-role="geo-menu"]')?.classList.remove('d-none');
  field.querySelector('[data-role="geo-toggle"]')?.setAttribute('aria-expanded', 'true');
  field.classList.add('is-open');
  positionMenu(field);
}

function closeMenu(field: HTMLElement): void {
  field.querySelector('[data-role="geo-menu"]')?.classList.add('d-none');
  field.querySelector('[data-role="geo-toggle"]')?.setAttribute('aria-expanded', 'false');
  field.classList.remove('is-open');
}

function closeAll(): void {
  document
    .querySelectorAll<HTMLElement>('.geo-locations-dropdown.is-open')
    .forEach(closeMenu);
}

export function refreshGeoSummaries(): void {
  document.querySelectorAll<HTMLElement>('.geo-locations-dropdown').forEach(summarize);
}

let initialized = false;

export function initGeoLocationDropdowns(): void {
  refreshGeoSummaries();
  if (initialized) return;
  initialized = true;

  const repositionOpenMenus = (): void => {
    document.querySelectorAll<HTMLElement>('.geo-locations-dropdown.is-open').forEach(positionMenu);
  };
  window.addEventListener('resize', repositionOpenMenus);
  document.addEventListener('scroll', repositionOpenMenus, true);

  document.addEventListener('click', (e) => {
    const target = e.target as HTMLElement;

    const toggle = target.closest<HTMLElement>('[data-role="geo-toggle"]');
    if (toggle) {
      const field = toggle.closest<HTMLElement>('.geo-locations-dropdown');
      if (!field || toggle.hasAttribute('disabled')) return;
      const isOpen = field.classList.contains('is-open');
      closeAll();
      if (!isOpen) openMenu(field);
      return;
    }

    // A click anywhere outside an open menu closes the dropdowns.
    if (!target.closest('.geo-locations-menu')) closeAll();
  });

  document.addEventListener('change', (e) => {
    const target = e.target as HTMLElement;
    if (!target.classList.contains('geo-location-checkbox')) return;
    const field = target.closest<HTMLElement>('.geo-locations-dropdown');
    if (field) summarize(field);
  });
}
